import { DateFormatter, now, parseDate, parseTime, today, toTime } from "@internationalized/date"
import { computedWithControl, useNow } from "@vueuse/core"
import { toDate } from "reka-ui/date"

const dateFormatter = new DateFormatter("en-US", { dateStyle: "medium" })

export function useTime(timeZone: string) {
    const clock = useNow({ interval: 60 * 1000 * 5 })

    const currentDate = computedWithControl(clock, () => today(timeZone))
    const currentTime = computedWithControl(clock, () => {
        let time = toTime(now(timeZone)).set({ second: 0, millisecond: 0 })
        if (time.minute < 30) {
            time = time.set({ minute: 30 })
        } else {
            time = time.add({ hours: 1 }).set({ minute: 0 })
        }
        return time
    })

    function formatDate(value: string) {
        const date = parseDate(value)
        if (date.compare(currentDate.value!) === 0) {
            return "Today"
        } else if (date.compare(currentDate.value!.add({ days: 1 })) === 0) {
            return "Tomorrow"
        }
        return dateFormatter.format(toDate(date)).split(",")[0]
    }

    function formatTime(value: string) {
        const time = parseTime(value)
        const hour = time.hour % 12 || 12
        const minute = time.minute < 10 ? `0${time.minute}` : time.minute
        const ampm = time.hour < 12 ? "AM" : "PM"
        return `${hour}:${minute} ${ampm}`
    }

    function isDateDisabled(date: any) {
        const year = date.year
        const month = date.month
        const day = date.day

        // January 1st
        if (month === 1 && day === 1) return true
        
        // Christmas Eve
        if (month === 12 && day === 24) return true
        
        // Christmas Day
        if (month === 12 && day === 25) return true
        
        // Thanksgiving (4th Thursday of November)
        if (month === 11) {
            const firstDay = new Date(year, 10, 1)
            const firstThursday = firstDay.getDay() === 4 ? 1 : (4 - firstDay.getDay() + 7) % 7 + 1
            const thanksgivingDay = firstThursday + 21
            if (day === thanksgivingDay) return true
        }
        
        return false
    }

    return {
        currentDate,
        currentTime,
        formatDate,
        formatTime,
        isDateDisabled
    }
}